function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { classnames, guid } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { RcAnchorItemProvider, useAnchor, useAnchorItem } from '../../hooks/anchor';
export function AnchorLink(props) {
  var title = props.title,
      href = props.href,
      children = props.children,
      className = props.className,
      onClick = props.onClick,
      extra = _objectWithoutProperties(props, ["title", "href", "children", "className", "onClick"]);

  var anchor = useAnchor();
  var id = useSingleton(function () {
    return guid();
  });

  var _useAnchorItem = useAnchorItem(href, id),
      anchorItem = _useAnchorItem.anchorItem,
      isActive = _useAnchorItem.isActive,
      startScroll = _useAnchorItem.startScroll,
      level = _useAnchorItem.level,
      activeDot = _useAnchorItem.activeDot,
      hashLink = _useAnchorItem.hashLink;

  var onClickCallback = useRefCallback(onClick);
  var activeOnClick = useCallback(function () {
    return anchor.setActiveItem(id);
  }, [id, anchor]);
  var handleClick = useCallback(function (e) {
    onClickCallback(e);
    activeOnClick();
    startScroll();
  }, [activeOnClick]);
  var cls = classnames(usePrefixCls('anchor-link'), className);
  var titleWrapperCls = usePrefixCls('anchor-link-title-wrapper', {
    level: String(level)
  });
  var titleCls = usePrefixCls('anchor-link-title', {
    active: isActive
  });
  var dotCls = usePrefixCls('anchor-link-dot', {
    active: activeDot && isActive
  });
  var options = {};
  hashLink && Object.assign(options, {
    href: href
  });
  return React.createElement(RcAnchorItemProvider, {
    anchorItem: anchorItem
  }, React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), React.createElement("a", Object.assign({}, options, {
    className: titleWrapperCls,
    onClick: handleClick
  }), React.createElement("span", {
    className: titleCls
  }, typeof title === 'function' ? title(isActive) : title), React.createElement("span", {
    className: dotCls
  })), children));
}